import * as _ from "lodash";
import {BaseInternalView, BaseInternalViewOptions} from "../_BaseViews";
import {UserCollection} from "../../collections/Users";
import {UserGroupCollection} from "../../collections/UserGroups";
import {BreadcrumbProperties, Breadcrumbs} from "../../common/breadcrumbs";
import {PermissionCollection} from "../../collections/Permissions";
import {ReportsCollection} from "../../collections/Reports";

export interface BaseAccountViewOptions extends BaseInternalViewOptions {
    reportsCollection: ReportsCollection;
    userGroupCollection: UserGroupCollection;
    userCollection: UserCollection;
    currentOrganizationId: number;
}

export abstract class BaseAccountView  extends BaseInternalView {

    options: BaseAccountViewOptions;

    protected currentOrganization: Backbone.Model;
    protected collectionLoaded: boolean = false;
    protected subViews: BaseAccountView[] = [];

    protected breadcrumbPathMap = {};
    protected breadcrumbDropDownOptions = {};

    constructor(options: BaseAccountViewOptions) {
        super(_.merge({
            events: {
                'input .table-filter-input': 'handleTableFilterChange'
            }
        }, options));

        this.currentOrganization = this.options.organizationCollection.findWhere({
            id: this.options.currentOrganizationId
        });

        this.handleTableFilterChange = _.debounce(this.handleTableFilterChange, 300);
    }

    abstract show(...args);

    protected generateBreadcrumbProperties(currentPath:string, searchByX:string): BreadcrumbProperties {
        var dropdownMap = _.clone(this.breadcrumbDropDownOptions);
        delete dropdownMap[currentPath];

        var pathMap = _.clone(this.breadcrumbPathMap);
        pathMap[currentPath] = this.breadcrumbDropDownOptions[currentPath];

        return {
            pathMap: pathMap,
            dropdownMap: dropdownMap,
            searchByX: searchByX
        }
    }

    protected showBreadcrumbs(currentPath: string, searchByX:string, properties?: BreadcrumbProperties) {
        var props = properties ? properties : this.generateBreadcrumbProperties(currentPath, searchByX);
        var breadcrumb = new Breadcrumbs(props);
        var container = $('.app-container ol').get();

        if (container.length < 1) {
            $('.app-container').append(breadcrumb.generateHTML());
        }
    }

    protected removeSubViews () {
        _.each(this.subViews, (v) => {v.remove()});
    }

    protected handleTableFilterChange(e: JQuery.UIEventBase) {
        var rows = $($(e.currentTarget).parents('.panel-default')).find('.row-colors .row').get();
        var filter = (<string> $(e.currentTarget).val()).toLowerCase();
        rows.reverse();

        _.each(rows, (row) => {
            var cells = $(row).find('div');
            var cellText = '';
            _.each(cells, (c) => {
                if(!$(c).attr('data-table-cell')) return;
                cellText+= $(c).attr('data-table-cell').toLowerCase();
            });

            if(cellText.indexOf(filter) !== -1){
                $(row).removeClass('hidden');
            } else {
                $(row).addClass('hidden');
            }

        });
    }

    remove() {
        this.removeSubViews();
        return super.remove();
    }

}

export abstract class BaseAccountListView extends BaseAccountView {

    protected template = _.template(require('templates/account/genericAccount.html'));
    protected panelTemplate = _.template(require('templates/account/panel.html'));

    abstract show(orgId, id?, detail?, subDetail?, subDetailId?);

    protected showTable() {};

    protected generateBreadcrumbProperties(currentPath, searchByX): BreadcrumbProperties {
        this.breadcrumbDropDownOptions = {
            'Users': '/#/account/' + this.options.currentOrganizationId + '/users',
            'Teams': '/#/account/' + this.options.currentOrganizationId + '/teams',
            'Dashboards': '/#/account/' + this.options.currentOrganizationId + '/dashboards',
            'Installations': '/#/account/' + this.options.currentOrganizationId + '/installs',
            'Reports': '/#/account/' + this.options.currentOrganizationId + '/reports',
            'Map View': '/#/account/' + this.options.currentOrganizationId + '/mapview',
        };
        var myApps = this.options.appCollection.where({
            organization_id: this.options.currentOrganizationId,
            enabled: 1
        });


        this.breadcrumbPathMap = {
            [this.currentOrganization.get('name')]: '/#/account/' + this.options.currentOrganizationId
        };

        return super.generateBreadcrumbProperties(currentPath, searchByX);
    }

}

export abstract class BaseAccountOverviewView extends BaseAccountView {

    protected groupPermissionCollections: {[groupId: number]: PermissionCollection} = {};
    protected currentDetail: string = null;

    protected template = _.template(require('templates/account/genericDetail.html'));

    abstract show(id, detail?, subDetail?, subDetailId?);
}


export interface BaseDetailAccountViewOptions extends BaseAccountViewOptions {
    isOverview: boolean
}

export abstract class BaseDetailAccountView extends BaseAccountView {

    options: BaseDetailAccountViewOptions;

    protected template = _.template(require('templates/account/panel.html'));

    abstract show(subDetail?, subDetailId?)
}



// WEBPACK FOOTER //
// ./srv/public/js/views/account/_BaseAccountViews.ts